// extracted by mini-css-extract-plugin
export default {"form":"styles_form__RpfKJ","container":"styles_container__L++TU","info":"styles_info__d9E8k"};